import { DateIntervalDto } from 'src/app/shared/model';

export * from './mission.component';
export * from './mission-form/mission-form.component';
export * from './mission-tracking/mission-tracking.component'




export class PlanificationAssignmentAddDto {
    id: number;
    idVehicule: number
    dateDebut: Date;
    dateFin: Date | undefined = null;
    monday: boolean;
    tuesday: boolean;
    wednesday: boolean;
    thursday: boolean;
    friday: boolean;
    saturday: boolean;
    label: string; 
    constructor() {

    }
}


export interface MissionSuiviRequest{
    dateInterval: DateIntervalDto;
    planId: number;
    timezoneOffset: number;
    all:boolean;
}